import React from 'react';
import { Box, Button } from '@mui/material';
import { ColorPalette } from '../config';
import { getCalendarViewDisplay, getHeaderTitle } from './calendar-helpers';
import { CalendarView } from './calendar-types';
import { ICalendarToolbarProps } from './calendar-toolbar-types';

const groupedCalendarViews: CalendarView[] = ['day', 'week', 'month', 'threeMonths', 'year'];

export function CalendarToolbarV2(props: ICalendarToolbarProps) {
  const {
    firstDate,
    onNextClick,
    onPreviousClick,
    onCalendarViewChange,
    currentCalendarView,
    onTodayClick,
    onAddEventClick,
  } = props;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        padding: '10px',
        backgroundColor: ColorPalette.LightHeaderBackground,
        borderRadius: '3px 3px 0 0',
        border: 'solid 1px rgba(0, 0, 0, 0.15)',
        borderBottom: 'none',
      }}
    >
      <Box display="flex" sx={{ justifySelf: 'start' }}>
        {currentCalendarView !== 'agenda' && (
          <>
            <Box
              sx={{
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Button
                size="small"
                variant="text"
                color="inherit"
                onClick={onPreviousClick}
                sx={{ minWidth: 0, px: 1.4, py: 0.1, fontSize: '1.15rem', lineHeight: 1, textTransform: 'none', borderRadius: 0 }}
              >
                ‹
              </Button>
              <Button
                size="small"
                variant="text"
                color="inherit"
                onClick={onNextClick}
                sx={{
                  minWidth: 0,
                  px: 1.4,
                  py: 0.1,
                  fontSize: '1.15rem',
                  lineHeight: 1,
                  textTransform: 'none',
                  borderRadius: 0,
                  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
                }}
              >
                ›
              </Button>
            </Box>
            <Box
              sx={{
                ml: 0.5,
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Button size="small" variant="text" color="inherit" onClick={onTodayClick} sx={{ minWidth: 0, px: 1.2, textTransform: 'none', borderRadius: 0 }}>
                I dag
              </Button>
            </Box>
            {onAddEventClick && (
              <Box
                sx={{
                  ml: 0.5,
                  border: '1px solid rgba(0, 0, 0, 0.23)',
                  borderRadius: 1,
                  overflow: 'hidden',
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={onAddEventClick}
                  sx={{ minWidth: 0, px: 1.2, textTransform: 'none', borderRadius: 0 }}
                >
                  Tilføj begivenhed
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>
      <Box sx={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: 500, textAlign: 'center', px: 2 }}>
        {getHeaderTitle(currentCalendarView, firstDate)}
      </Box>
      <Box
        display="flex"
        sx={{
          justifySelf: 'end',
          alignItems: 'center',
          fontFamily: 'Roboto',
          fontSize: '14px',
          fontWeight: 500,
        }}
      >
        <Box
          sx={{
            mr: 0.5,
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: 1,
            overflow: 'hidden',
          }}
        >
          <Button
            size="small"
            variant={currentCalendarView === 'agenda' ? 'contained' : 'text'}
            color={currentCalendarView === 'agenda' ? 'primary' : 'inherit'}
            onClick={() => onCalendarViewChange('agenda')}
            sx={{ minWidth: 0, px: 1.2, textTransform: 'none', borderRadius: 0 }}
          >
            {getCalendarViewDisplay('agenda')}
          </Button>
        </Box>
        <Box
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: 1,
            overflow: 'hidden',
          }}
        >
          {groupedCalendarViews.map((view, index) => (
            <Button
              key={view}
              size="small"
              variant={currentCalendarView === view ? 'contained' : 'text'}
              color={currentCalendarView === view ? 'primary' : 'inherit'}
              onClick={() => onCalendarViewChange(view)}
              sx={{
                minWidth: 0,
                px: 1.2,
                textTransform: 'none',
                borderRadius: 0,
                ...(index > 0 ? { borderLeft: '1px solid rgba(0, 0, 0, 0.12)' } : {}),
              }}
            >
              {getCalendarViewDisplay(view)}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
